export default [
    {
        path: '/heishop/monitoreo',
        name: 'heishop-monitoreo',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/monitoreo/Monitoreo.vue')
    },
    {
        path: '/heishop/monitoreo/historial',
        name: 'heishop-monitoreo-historial',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/monitoreo/Historial.vue')
    },
]